import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import CookieUtil from 'tradera-utils/cookie';
import { GDPR_CONSENT_COOKIE } from 'tradera-constants/cookies';

const WaitForConsentApiLoaded = ({
    adsCheckGdprCookie,
    placeHolder,
    onLoadRender
}) => {
    const hasGivenConsent = adsCheckGdprCookie
        ? CookieUtil.readCookie(GDPR_CONSENT_COOKIE)
        : true;
    const isTcfLoaded = useSelector(state => state.ads.isTcfLoaded);
    if (!isTcfLoaded && !hasGivenConsent) return null;
    if (!isTcfLoaded && placeHolder) return placeHolder; // Return ads placeholder until Tcf is loaded
    return <>{onLoadRender()}</>;
};

WaitForConsentApiLoaded.propTypes = {
    adsCheckGdprCookie: PropTypes.bool.isRequired,
    placeHolder: PropTypes.node,
    onLoadRender: PropTypes.func.isRequired
};

export default WaitForConsentApiLoaded;
